import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { ContentfulImage } from '@stadionhq-v3/contentful-ui';
import { PullQuoteEmbedProps } from '@stadionhq-v3/base-ui';
import { PullQuoteEmbed } from '@graphql/index';
import { QuoteMark } from '@components/icons';

const pullQuoteEmbedTransform = ({
  quote,
  firstName,
  lastName,
  subTitle,
  avatar,
}: CleanContentful<PullQuoteEmbed>): PullQuoteEmbedProps => ({
  quote,
  firstName: firstName || '',
  secondName: lastName || '',
  subTitle: subTitle || '',
  avatar: avatar && <ContentfulImage {...avatar} />,
  quoteIcon: <QuoteMark />,
});

export default pullQuoteEmbedTransform;
